import React from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Switch from '@mui/material/Switch';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

import MKBox from 'components/MKBox';
import MKTypography from 'components/MKTypography';
import MKButton from 'components/MKButton';

import { commonInputProps, selectInputProps, secondaryButtonSx } from '../utils/constants';

function ExperienceModal({ open, handleClose, form, setForm, onSave, errors }) {
  // Obtenemos la fecha de hoy en formato YYYY-MM-DD para el atributo max
  const today = new Date().toISOString().split('T')[0];

  const handleSwitchChange = (e) => {
    setForm((prev) => ({
      ...prev,
      actualmente: e.target.checked,
      fechaFin: e.target.checked ? '' : prev.fechaFin,
    }));
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="md"
      PaperProps={{ sx: { borderRadius: 3, p: 1.5 } }}
    >
      <DialogTitle sx={{ pb: 0.5 }}>
        <MKTypography variant="h3" color="info" fontWeight="bold">
          Agregar Experiencia
        </MKTypography>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2.5} sx={{ pt: 2 }}>
          <Grid item xs={12} md={6}>
            <TextField
              label="Cargo"
              placeholder="P. ej., responsable de ventas minoristas"
              value={form.cargo}
              onChange={(e) => setForm((p) => ({ ...p, cargo: e.target.value }))}
              error={!!errors.cargo}
              helperText={errors.cargo}
              {...commonInputProps}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Empresa u organización"
              placeholder="P. ej., Microsoft"
              value={form.empresa}
              onChange={(e) => setForm((p) => ({ ...p, empresa: e.target.value }))}
              error={!!errors.empresa}
              helperText={errors.empresa}
              {...commonInputProps}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              label="Tipo de empleo"
              value={form.tipoEmpleo}
              onChange={(e) => setForm((p) => ({ ...p, tipoEmpleo: e.target.value }))}
              error={!!errors.tipoEmpleo} // Visualización de error
              helperText={errors.tipoEmpleo} // Mensaje de error
              {...selectInputProps}
            >
              <MenuItem value="full-time">Jornada completa</MenuItem>
              <MenuItem value="part-time">Jornada parcial</MenuItem>
              <MenuItem value="self-employed">Por cuenta propia</MenuItem>
              <MenuItem value="freelance">Autónomo</MenuItem>
              <MenuItem value="contract">Contrato por obra o servicio</MenuItem>
              <MenuItem value="internship">Prácticas</MenuItem>
              <MenuItem value="apprenticeship">Prácticas laborales</MenuItem>
              <MenuItem value="seasonal">Trabajo de temporada</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Tipo de ubicación"
              value={form.modalidad || ''}
              onChange={(e) => setForm((p) => ({ ...p, modalidad: e.target.value }))}
              error={!!errors.modalidad}
              helperText={errors.modalidad}
              {...selectInputProps}
            >
              <MenuItem value="Presencial">Presencial</MenuItem>
              <MenuItem value="Híbrido">Híbrido</MenuItem>
              <MenuItem value="Remoto">En remoto</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12}>
            <MKBox display="flex" alignItems="center">
              <Switch checked={!!form.actualmente} onChange={handleSwitchChange} color="info" />
              <MKTypography variant="button" ml={1}>
                Actualmente tengo este cargo
              </MKTypography>
            </MKBox>
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              type="date"
              label="Fecha de inicio"
              value={form.fechaInicio}
              onChange={(e) => setForm((p) => ({ ...p, fechaInicio: e.target.value }))}
              error={!!errors.fechaInicio}
              helperText={errors.fechaInicio}
              {...commonInputProps}
              inputProps={{ max: today }} // BLOQUEO DE FECHA FUTURA
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              type="date"
              label="Fecha de finalización"
              value={form.fechaFin}
              onChange={(e) => setForm((p) => ({ ...p, fechaFin: e.target.value }))}
              disabled={form.actualmente}
              error={!!errors.fechaFin}
              helperText={errors.fechaFin}
              {...commonInputProps}
              inputProps={{ max: today }} // BLOQUEO DE FECHA FUTURA
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Descripción"
              value={form.descripcion}
              onChange={(e) => setForm((p) => ({ ...p, descripcion: e.target.value }))}
              multiline
              minRows={4}
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              sx={{ '& .MuiOutlinedInput-root': { padding: '12px' } }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <MKButton variant="contained" size="large" onClick={handleClose} sx={secondaryButtonSx}>
          Atrás
        </MKButton>
        <MKButton variant="contained" color="info" size="large" onClick={onSave}>
          Guardar
        </MKButton>
      </DialogActions>
    </Dialog>
  );
}

export default ExperienceModal;
